import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import { Dialog } from '@material-ui/core';
import ShopTableHead from '../../components/molecules/ShopTableHead';
import ShopTableBody from '../../components/molecules/ShopTableBody';
import ShopEdit from './ShopEdit';
import ShopDetail from './ShopDetail';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import SortDialog from '../../components/molecules/SortDialog';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import ChangeStatusShopShowDialog from '../../components/molecules/ChangeStatusShopShowDialog';
import {
  getShops,
  getShopDetail,
  downloadQrCode,
  linkPaymentShop,
  LINK_PAYMENT_SHOP_SUCCESS,
  updateShopSettingGochiKidUnlimit,
  UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_SUCCESS,
  updateAllowGapPayment,
  UPDATE_ALLOW_GAP_PAYMENT_SUCCESS
} from '../../actions/Shop';
import { sendLogin } from '../../auth/Auth';
import {
  resetUserPasswordData,
  closeShopData,
  statusShopData,
  getShopConnectSystemData,
  updateShopConnectSystemData,
  changeUserPasswordData
} from '../../libs/apis/ShopApi';
import { getOptionCities } from '../../actions/Cities';
import paymentTypes from '../../constants/PaymentTypes';
import {
  getBankList,
  getBankBranchList,
  GET_BANK_BRANCH_LIST_SUCCESS,
  GET_BANK_LIST_SUCCESS
} from '../../actions/Bank';
import GochiKidUnlimitModalShop from '../../components/molecules/GochiKidUnlimitModalShop';
import GochiKidReceiptModalShop from '../../components/molecules/GochiKidReceiptModalShop';
import {
  settingGochiKidReceiptShop,
  SETTING_GOCHI_KID_RECEIPT_SHOP_SUCCESS
} from '../../actions/GochiKidReceipt';
import ChangeAllowGapPaymentDialog from '../../components/molecules/ChangeAllowGapPaymentDialog';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops.shops,
      totalCount: state.shops.totalCount,
      offset: state.shops.offset,
      accessibleShops: state.shops.accessibleShops,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getShops,
          getShopDetail,
          downloadQrCode,
          getOptionCities,
          linkPaymentShop,
          getBankList,
          getBankBranchList,
          updateShopSettingGochiKidUnlimit,
          settingGochiKidReceiptShop,
          updateAllowGapPayment
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('loading', 'updateLoading', false),
  withState('openSort', 'updateOpenSort', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('targetColumn', 'setTargetColumn', ''),
  withState('openTable', 'updateOpenTable', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('statusShop', 'setStatusShop', 'AVAILABLE'),
  withState('message', 'setMessage', ''),
  withState('sortServer', 'setSortServer', false),
  withState('openChangeShopShow', 'updateOpenChangeShopShow', false),
  withState(
    'openChangeShopShowConfirm',
    'updateOpenChangeShopShowConfirm',
    false
  ),
  withState('shopConnectSystem', 'updateShopConnectSystem', {}),
  withState('idShopShow', 'updateIdShopShow', ''),
  withState('openProgress', 'updateOpenProgress', false),
  withState('detail', 'setDetail', {}),
  withState('listBank', 'setListBank', []),
  withState('listBankBranch', 'setListBankBranch', []),
  withState('shopChoice', 'setShopChoice', null),
  withState(
    'openSettingUnlimitGochiKidModal',
    'updateOpenSettingUnlimitGochiKidModal',
    false
  ),
  withState(
    'openSettingGochiKidReceiptModal',
    'updateOpenSettingGochiKidReceiptModal',
    false
  ),
  withState(
    'openAllowGapPaymentModal',
    'updateOpenAllowGapPaymentModal',
    false
  ),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      props.setSortServer(false);
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionCities();
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    progress,
    searchKey,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    shops,
    openDetailModal,
    updateOpenDetailModal,
    openSort,
    updateOpenSort,
    openEditModal,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    targetColumn,
    setTargetColumn,
    searchSortKey,
    sortOrder,
    // sortType,
    resultMessage,
    setResultMessage,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    // openTable,
    // updateOpenTable,
    sortClientAction,
    sortServerAction,
    rowsPerPage,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort,
    statusShop,
    setStatusShop,
    message,
    setMessage,
    // setOrder,
    // setOrderBy
    sortServer,
    setSortServer,
    openChangeShopShow,
    updateOpenChangeShopShow,
    openChangeShopShowConfirm,
    updateOpenChangeShopShowConfirm,
    shopConnectSystem,
    updateShopConnectSystem,
    idShopShow,
    updateIdShopShow,
    detail,
    setDetail,
    shopCategories,
    listBank,
    setListBank,
    listBankBranch,
    setListBankBranch,
    shopChoice,
    setShopChoice,
    openSettingUnlimitGochiKidModal,
    updateOpenSettingUnlimitGochiKidModal,
    openSettingGochiKidReceiptModal,
    updateOpenSettingGochiKidReceiptModal,
    openAllowGapPaymentModal,
    updateOpenAllowGapPaymentModal
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    // function add text (Water-Mark) to image qr code
    const addWaterMark = async blob => {
      const canvas = await new Promise(resolve => {
        const objectURL = URL.createObjectURL(blob);
        const c = document.createElement('canvas');
        c.width = 390;
        c.height = 390;
        const ctx = c.getContext('2d');
        const img = new Image();

        img.onload = () => {
          ctx.drawImage(img, 0, 0);
          ctx.fillStyle = 'red';
          ctx.textBaseline = 'bottom';
          ctx.font = "18px 'Roboto', 'Helvetica', 'Arial', sans-serif";
          ctx.fillText('', 42, 376);
          resolve(c);
        };
        img.src = objectURL;
        console.log('objectURL', objectURL);
      });

      return new Promise(resolve => {
        canvas.toBlob(
          newblob => {
            resolve(newblob);
          },
          'image/jpeg',
          1
        );
      });
    };

    const downloadQrBlob = async (blob, fileName) => {
      const newBlob = await addWaterMark(blob);
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(newBlob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(
          new Blob([newBlob], { type: 'image/jpeg' })
        );
        console.log('url', url);
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const linkPaypayAction = id => {
      updateLoading(true);
      updateOpenProgress(true);
      actions
        .linkPaymentShop({
          shopId: id,
          paymentMethods: [
            {
              paymentType: paymentTypes.PAYPAY,
              status: 1
            }
          ]
        })
        .then(async data => {
          if (data.type === LINK_PAYMENT_SHOP_SUCCESS) {
            updateLoading(false);
            setResultMessage(data.payload);
          } else {
            updateLoading(false);
            setResultMessage('エラーが発生しました。');
          }
        })
        .catch(() => {
          alert('エラーが発生しました。');
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const linkOnepayAction = id => {
      updateLoading(true);
      updateOpenProgress(true);
      actions
        .linkPaymentShop({
          shopId: id,
          paymentMethods: [
            {
              paymentType: paymentTypes.ONEPAY_ALIPAY,
              status: 1
            }
          ]
        })
        .then(async data => {
          if (data.type === LINK_PAYMENT_SHOP_SUCCESS) {
            updateLoading(false);
            setResultMessage(data.payload);
          } else {
            updateLoading(false);
            setResultMessage('エラーが発生しました。');
          }
        })
        .catch(() => {
          alert('エラーが発生しました。');
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const linkWechatPayAction = id => {
      updateLoading(true);
      updateOpenProgress(true);
      actions
        .linkPaymentShop({
          shopId: id,
          paymentMethods: [
            {
              paymentType: paymentTypes.WECHATPAY,
              status: 1
            }
          ]
        })
        .then(async data => {
          if (data.type === LINK_PAYMENT_SHOP_SUCCESS) {
            updateLoading(false);
            setResultMessage(data.payload);
          } else {
            updateLoading(false);
            setResultMessage('エラーが発生しました。');
          }
        })
        .catch(() => {
          alert('エラーが発生しました。');
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const unlinkPaypayAction = id => {
      updateLoading(true);
      updateOpenProgress(true);
      actions
        .linkPaymentShop({
          shopId: id,
          paymentMethods: [
            {
              paymentType: paymentTypes.PAYPAY,
              status: 0
            }
          ]
        })
        .then(async data => {
          if (data.type === LINK_PAYMENT_SHOP_SUCCESS) {
            updateLoading(false);
            setResultMessage(data.payload);
          } else {
            updateLoading(false);
            setResultMessage('エラーが発生しました。');
          }
        })
        .catch(() => {
          alert('エラーが発生しました。');
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const unlinkOnepayAction = id => {
      updateLoading(true);
      updateOpenProgress(true);
      actions
        .linkPaymentShop({
          shopId: id,
          paymentMethods: [
            {
              paymentType: paymentTypes.ONEPAY_ALIPAY,
              status: 0
            }
          ]
        })
        .then(async data => {
          if (data.type === LINK_PAYMENT_SHOP_SUCCESS) {
            updateLoading(false);
            setResultMessage(data.payload);
          } else {
            updateLoading(false);
            setResultMessage('エラーが発生しました。');
          }
        })
        .catch(() => {
          alert('エラーが発生しました。');
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const unlinkWechatPayAction = id => {
      updateLoading(true);
      updateOpenProgress(true);
      actions
        .linkPaymentShop({
          shopId: id,
          paymentMethods: [
            {
              paymentType: paymentTypes.WECHATPAY,
              status: 0
            }
          ]
        })
        .then(async data => {
          if (data.type === LINK_PAYMENT_SHOP_SUCCESS) {
            updateLoading(false);
            setResultMessage(data.payload);
          } else {
            updateLoading(false);
            setResultMessage('エラーが発生しました。');
          }
        })
        .catch(() => {
          alert('エラーが発生しました。');
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const getShop = async id => {
      await actions.getShopDetail(id).then(detailData => {
        checkSession(detailData);
        const dataDetail = _.cloneDeep(detailData.payload);
        if (
          typeof detailData.payload.tags !== 'undefined' &&
          detailData.payload.tags !== null
        ) {
          dataDetail.tags = detailData.payload.tags;
          dataDetail.tagStr = detailData.payload.tags
            .map(tag => {
              return `${tag.tagName}`;
            })
            .join(' ');
        } else {
          dataDetail.tags = [];
          dataDetail.tagStr = '';
        }
        if (
          typeof detailData.payload.images !== 'undefined' &&
          detailData.payload.images !== null
        ) {
          dataDetail.images = detailData.payload.images;
        } else {
          dataDetail.images = [];
        }
        if (
          typeof detailData.payload.shopAnniversaries !== 'undefined' &&
          detailData.payload.shopAnniversaries !== null
        ) {
          dataDetail.shopAnniversaries = detailData.payload.shopAnniversaries;
        } else {
          dataDetail.shopAnniversaries = [];
        }
        if (
          typeof detailData.payload.bankAccount !== 'undefined' &&
          detailData.payload.bankAccount !== null
        ) {
          dataDetail.bankName = detailData.payload.bankAccount.bankName;
          dataDetail.bankBranchName =
            detailData.payload.bankAccount.bankBranchName;
          dataDetail.bankAccountType =
            detailData.payload.bankAccount.bankAccountType;
          dataDetail.bankAccountTypeStr =
            detailData.payload.bankAccount.bankAccountTypeStr;
          dataDetail.bankAccountNumber =
            detailData.payload.bankAccount.bankAccountNumber;
          dataDetail.bankAccountHolder =
            detailData.payload.bankAccount.bankAccountHolder;
          dataDetail.bankCode = detailData.payload.bankAccount.bankCode;
          dataDetail.bankBranchCode =
            detailData.payload.bankAccount.bankBranchCode;
        } else {
          dataDetail.bankName = '';
          dataDetail.bankBranchName = '';
          dataDetail.bankAccountType = 'SAVINGS';
          dataDetail.bankAccountTypeStr = '普通預金';
          dataDetail.bankAccountNumber = '';
          dataDetail.bankAccountHolder = '';
          dataDetail.bankCode = '';
          dataDetail.bankBranchCode = '';
        }
        dataDetail.shopCategories = shopCategories;
        setDetail(dataDetail);
      });
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getShop(params.id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = async id => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      const bankResponse = await actions
        .getBankList()
        .then(data => checkSession(data));
      if (bankResponse.type === GET_BANK_LIST_SUCCESS) {
        setListBank(bankResponse.payload);
      } else {
        setListBank([]);
      }
      const bankBranchResponse = await actions
        .getBankBranchList()
        .then(data => checkSession(data));
      if (bankBranchResponse.type === GET_BANK_BRANCH_LIST_SUCCESS) {
        setListBankBranch(bankBranchResponse.payload);
      } else {
        setListBankBranch([]);
      }
      await getShop(id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEditModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const sortOpenAction = prop => {
      setSortServer(true);
      updateOpenSort(true);
      setTargetColumn(prop);
      // const isDesc = order === 'desc';
      // setOrder(isDesc ? 'asc' : 'desc');
      // setOrderBy(prop);
    };
    const cancelSortAction = () => updateOpenSort(false);

    // const sortClientAction = async () => {
    //   updateLoading(true);
    //   handleRequestSort(targetColumn);
    //   updateOpenSort(false);
    // };

    const qrCodeAction = (id, name) => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      actions.downloadQrCode(id).then(response => {
        checkSession(response);
        if (response.type === 'DOWNLOAD_QRCODE_SUCCESS') {
          console.log('response.payload', response);
          progress.updateOpenProgress(false);
          progress.setResultMessage('');
          progress.updateLoading(false);
          downloadQrBlob(response.payload, `${name}.jpg`);
        } else {
          progress.setResultMessage('QRコードダウンロードに失敗しました。');
          progress.updateLoading(false);
        }
      });
    };
    const resetPasswordAction = (params, type, newpass = null) => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      if (type === '1') {
        resetUserPasswordData({ shopId: params.id })
          .then(async data => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
            if (data.data === 0)
              alert(`${params.shopName}のパスワードをリセットしました。`);
            else alert('パスワードがリセットされません。');
          })
          .catch(() => {
            alert('パスワードがリセットされません。');
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
          });
      } else if (type === '2') {
        changeUserPasswordData({ shopId: params.id, password: newpass })
          .then(async data => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
            if (data.data === 0)
              alert(`${params.shopName}のパスワードを変更しました。`);
            else alert('変更に失敗しました。');
          })
          .catch(() => {
            alert('変更に失敗しました。');
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
          });
      }
    };
    // const closeShopAction = params => {
    //   progress.updateLoading(true);
    //   progress.updateOpenProgress(true);
    //   closeShopData({ shopId: params.id })
    //     .then(async data => {
    //       progress.updateOpenProgress(false);
    //       progress.updateLoading(false);
    //       console.log(data);
    //       console.log(data.data.code);
    //       if (data.data.code === 200) alert('この店舗を閉店しました。');
    //       else alert('この店舗をまだ閉店しません。');
    //     })
    //     .catch(() => {
    //       alert('この店舗をまだ閉店しません。');
    //       progress.updateOpenProgress(false);
    //       progress.updateLoading(false);
    //     });
    // };

    const changeStatusShopAction = params => {
      console.log(params);
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      if (params.status === 'CLOSED') {
        // change status shop to closed
        closeShopData({ shopId: params.shopId })
          .then(async data => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
            console.log(data);
            console.log(data.data.code);
            if (data.data.code === 200) {
              alert('開店状況を変更しました。');
              handleChangePage(null, 1, rowsPerPage.textContent);
            } else {
              alert('開店状況の変更は失敗しました。');
            }
          })
          .catch(() => {
            alert('開店状況の変更は失敗しました。');
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
          });
      } else if (params.status === 'PRE_AVAILABLE') {
        // change status shop to available
        statusShopData(params)
          .then(async data => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
            console.log(data);
            console.log(data.data.code);
            if (data.data.code === 200) {
              alert('開店状況を変更しました。');
              handleChangePage(null, 1, rowsPerPage.textContent);
            } else {
              alert('開店状況の変更は失敗しました。');
            }
          })
          .catch(() => {
            alert('開店状況の変更は失敗しました。');
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
          });
      } else if (params.status === 'SUSPENDED') {
        // change status shop to suspended
        statusShopData(params)
          .then(async data => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
            console.log(data);
            console.log(data.data.code);
            if (data.data.code === 200) {
              alert('開店状況を変更しました。');
              handleChangePage(null, 1, rowsPerPage.textContent);
            } else {
              alert('開店状況の変更は失敗しました。');
            }
          })
          .catch(() => {
            alert('開店状況の変更は失敗しました。');
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
          });
      } else if (params.status === 'AVAILABLE') {
        // change status shop to available
        statusShopData(params)
          .then(async data => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
            console.log(data);
            console.log(data.data.code);
            if (data.data.code === 200) {
              alert('開店状況を変更しました。');
              handleChangePage(null, 1, rowsPerPage.textContent);
            } else {
              alert('開店状況の変更は失敗しました。');
            }
          })
          .catch(() => {
            alert('開店状況の変更は失敗しました。');
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
          });
      } else {
        progress.updateOpenProgress(false);
        progress.updateLoading(false);
      }
    };

    const changeStatusShopShowShashoku = id => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getShopConnectSystemData(id)
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          console.log(data);
          console.log(data.status);
          if (data.status === 200) {
            updateIdShopShow(id);
            updateShopConnectSystem(data.data);
            updateOpenChangeShopShow(true);
          } else {
            alert('エラーが発生しました。');
            updateShopConnectSystem({});
          }
        })
        .catch(() => {
          alert('エラーが発生しました。');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    const updateStatusShopShowShashoku = id => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      updateShopConnectSystemData(id, shopConnectSystem)
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          console.log(data);
          console.log(data.status);
          if (data.status === 200) {
            handleChangePage(null, 1, rowsPerPage.textContent);
            updateOpenChangeShopShowConfirm(false);
            updateOpenChangeShopShow(false);
          } else {
            alert('エラーが発生しました。');
            updateOpenChangeShopShowConfirm(false);
          }
        })
        .catch(() => {
          alert('エラーが発生しました。');
          updateOpenChangeShopShowConfirm(false);
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    const cancelOpenChangeShopShow = () => updateOpenChangeShopShow(false);

    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(false);
      handleChangePage(null, 1, rowsPerPage.textContent);
    };

    const handeOpenSettingUnlimitGochiKidModal = shop => {
      setShopChoice(shop);
      updateOpenSettingUnlimitGochiKidModal(true);
    };

    const updateSettingUnlimitGochiKid = async () => {
      updateOpenProgress(true);
      updateLoading(true);
      const params = {
        gochiKidUnlimit: shopChoice.gochiKidUnlimit === 1 ? 0 : 1
      };

      await actions
        .updateShopSettingGochiKidUnlimit(shopChoice.shopId, params)
        .then(data => {
          checkSession(data);
          if (data.type === UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_SUCCESS) {
            updateOpenSettingUnlimitGochiKidModal(false);
            setResultMessage('設定更新を完了しました。');
            updateLoading(false);
          } else {
            alert('エラーが発生しました。');
            updateOpenProgress(false);
            updateLoading(false);
          }
        });
    };

    const handeOpenSettingGochiKidReceiptModal = shop => {
      setShopChoice(shop);
      updateOpenSettingGochiKidReceiptModal(true);
    };

    const updateSettingGochiKidReceipt = async () => {
      updateOpenProgress(true);
      updateLoading(true);
      const params = {
        shopId: shopChoice.shopId,
        gochiKidReceipt: shopChoice.shopDetail.gochiKidReceipt === 1 ? 0 : 1
      };

      await actions.settingGochiKidReceiptShop(params).then(data => {
        checkSession(data);
        if (data.type === SETTING_GOCHI_KID_RECEIPT_SHOP_SUCCESS) {
          updateOpenSettingGochiKidReceiptModal(false);
          setResultMessage('設定更新を完了しました。');
          updateLoading(false);
        } else {
          alert('エラーが発生しました。');
          updateOpenProgress(false);
          updateLoading(false);
        }
      });
    };

    const handleOpenChangeAllowGapPaymentModal = shop => {
      setShopChoice(shop);
      updateOpenAllowGapPaymentModal(true);
    };

    const settingAllowGapPayment = async allowGapPayment => {
      updateOpenProgress(true);
      updateLoading(true);
      const params = {
        shopId: shopChoice.shopId,
        allowGapPayment
      };

      await actions.updateAllowGapPayment(params).then(data => {
        checkSession(data);
        if (data.type === UPDATE_ALLOW_GAP_PAYMENT_SUCCESS) {
          updateOpenAllowGapPaymentModal(false);
          setResultMessage('変更しました。');
          updateLoading(false);
        } else {
          alert('エラーが発生しました。');
          updateOpenProgress(false);
          updateLoading(false);
        }
      });
    };

    return (
      <div>
        {totalCount > 100 && (
          <div className={classes.scrollTable} id="scrollTableId">
            <Table stickyHeader>
              <ShopTableHead
                order={sortServer ? sortOrder : order}
                orderBy={sortServer ? searchSortKey : orderBy}
                onRequestSort={sortOpenAction}
                onRequestSortClient={handleRequestSort}
                roles={roles}
              />
              <ShopTableBody
                shops={shops}
                emptyRows={emptyRows}
                page={page}
                rowsPerPage={rowsPerPage}
                detailOpenAction={detailOpenAction}
                editOpenAction={editOpenAction}
                qrCodeAction={qrCodeAction}
                roles={roles}
                order={sortServer ? sortOrder : order}
                orderBy={sortServer ? searchSortKey : orderBy}
                resetPasswordAction={resetPasswordAction}
                changeStatusShopAction={changeStatusShopAction}
                statusShop={statusShop}
                setStatusShop={setStatusShop}
                message={message}
                setMessage={setMessage}
                // searchSortKey={searchSortKey}
                changeStatusShopShowAction={changeStatusShopShowShashoku}
                linkPaypayAction={linkPaypayAction}
                unlinkPaypayAction={unlinkPaypayAction}
                linkOnepayAction={linkOnepayAction}
                unlinkOnepayAction={unlinkOnepayAction}
                linkWechatPayAction={linkWechatPayAction}
                unlinkWechatPayAction={unlinkWechatPayAction}
                searchKey={searchKey}
                handeOpenSettingUnlimitGochiKidModal={
                  handeOpenSettingUnlimitGochiKidModal
                }
                handeOpenSettingGochiKidReceiptModal={
                  handeOpenSettingGochiKidReceiptModal
                }
                handleOpenChangeAllowGapPaymentModal={
                  handleOpenChangeAllowGapPaymentModal
                }
              />
            </Table>
          </div>
        )}
        {totalCount <= 100 && (
          <div className={classes.scrollTable} id="scrollTableId">
            <Table stickyHeader>
              <ShopTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                roles={roles}
                onRequestSortClient={handleRequestSort}
              />
              <ShopTableBody
                shops={shops}
                emptyRows={emptyRows}
                page={page}
                rowsPerPage={rowsPerPage}
                detailOpenAction={detailOpenAction}
                editOpenAction={editOpenAction}
                qrCodeAction={qrCodeAction}
                roles={roles}
                order={order}
                orderBy={orderBy}
                resetPasswordAction={resetPasswordAction}
                changeStatusShopAction={changeStatusShopAction}
                statusShop={statusShop}
                setStatusShop={setStatusShop}
                message={message}
                setMessage={setMessage}
                changeStatusShopShowAction={changeStatusShopShowShashoku}
                linkPaypayAction={linkPaypayAction}
                unlinkPaypayAction={unlinkPaypayAction}
                linkOnepayAction={linkOnepayAction}
                unlinkOnepayAction={unlinkOnepayAction}
                linkWechatPayAction={linkWechatPayAction}
                unlinkWechatPayAction={unlinkWechatPayAction}
                searchKey={searchKey}
                handeOpenSettingUnlimitGochiKidModal={
                  handeOpenSettingUnlimitGochiKidModal
                }
                handeOpenSettingGochiKidReceiptModal={
                  handeOpenSettingGochiKidReceiptModal
                }
                handleOpenChangeAllowGapPaymentModal={
                  handleOpenChangeAllowGapPaymentModal
                }
              />
            </Table>
          </div>
        )}
        {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
          <div>
            <ExPagination
              searchResults={shops}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalCount}
              offset={offset}
              selectedPage={selectedPage}
              searchSortKey={searchSortKey}
              sortOrder={sortOrder}
              // sortType={sortType}
            />
          </div>
        )}
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
        >
          <ShopDetail
            updateOpenDetailModal={updateOpenDetailModal}
            detail={detail}
            roles={roles}
          />
        </Modal>
        <Modal open={openEditModal}>
          <ShopEdit
            updateOpenEditModal={updateOpenEditModal}
            openEditConfirm={openEditConfirm}
            updateOpenEditConfirm={updateOpenEditConfirm}
            roles={roles}
            editInput={detail}
            searchKey={searchKey}
            listBank={listBank}
            listBankBranch={listBankBranch}
          />
        </Modal>
        <ChangeStatusShopShowDialog
          openChange={openChangeShopShow}
          updateOpenChange={updateOpenChangeShopShow}
          cancelAction={cancelOpenChangeShopShow}
          message={message}
          setMessage={setMessage}
          openChangeConfirm={openChangeShopShowConfirm}
          updateOpenChangeConfirm={updateOpenChangeShopShowConfirm}
          shopConnectSystem={shopConnectSystem}
          updateShopConnectSystem={updateShopConnectSystem}
          changeAction={updateStatusShopShowShashoku}
          idShopShow={idShopShow}
        />
        <SortDialog
          openSort={openSort}
          updateOpenSort={updateOpenSort}
          cancelAction={cancelSortAction}
          sortClientAction={sortClientAction}
          sortServerAction={sortServerAction}
          targetColumn={targetColumn}
          order={order}
          orderBy={orderBy}
          roles={roles}
          // sortTypeParamServer="server"
          // sortTypeParamClient="client"
          searchSortKeyColumn={targetColumn}
          sortOrderParam={sortOrder}
        />
        <Modal
          className={classes.modal}
          open={openSettingUnlimitGochiKidModal}
          onClose={() => {
            updateOpenSettingUnlimitGochiKidModal(false);
          }}
        >
          <GochiKidUnlimitModalShop
            shop={shopChoice}
            updateOpenSettingUnlimitGochiKidModal={
              updateOpenSettingUnlimitGochiKidModal
            }
            updateSettingUnlimitGochiKid={updateSettingUnlimitGochiKid}
          />
        </Modal>
        <Modal
          className={classes.modal}
          open={openSettingGochiKidReceiptModal}
          onClose={() => {
            updateOpenSettingGochiKidReceiptModal(false);
          }}
        >
          <GochiKidReceiptModalShop
            shop={shopChoice}
            updateOpenSettingGochiKidReceiptModal={
              updateOpenSettingGochiKidReceiptModal
            }
            updateSettingGochiKidReceipt={updateSettingGochiKidReceipt}
          />
        </Modal>

        <Dialog
          open={openAllowGapPaymentModal}
          onClose={() => {
            updateOpenAllowGapPaymentModal(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <ChangeAllowGapPaymentDialog
            openChange={openAllowGapPaymentModal}
            updateOpenChange={updateOpenAllowGapPaymentModal}
            shop={shopChoice}
            submitAction={settingAllowGapPayment}
          />
        </Dialog>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
